module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-103@3x__ed032a42eb440bde0c9d65ffca25835f.png";